"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lib = require("../../lib");

var _common = require("../../common");

var _Option = _interopRequireDefault(require("./Option"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SelectBase =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SelectBase, _PureComponent);

  _createClass(SelectBase, null, [{
    key: "mapOption",
    value: function mapOption(option) {
      if ((0, _lib.isObj)(option)) {
        var title = option.title,
            label = option.label,
            text = option.text,
            name = option.name;
        return Object.assign({}, option, {
          title: title || label || text || name // set all possible Text to title property

        });
      }

      return {
        title: option,
        value: option
      };
    }
  }]);

  function SelectBase(props) {
    var _this;

    _classCallCheck(this, SelectBase);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectBase).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "innerRef", _react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      var names = [SelectBase.className];
      (0, _lib.addClassByPropName)(names, _this.props, ['multiple']);
      (0, _lib.addClassByPropName)(names, _this.state, ['active']);
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e) {
      (0, _lib.callEventMethods)(e, 'persist');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var value = (0, _lib.getEventKey)(e);

      _this.setState({
        value: value
      }, function () {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;

        if (onChange) {
          onChange(e, {
            name: name,
            value: value
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnSelect", function (e, _ref) {
      var value = _ref.value;
      (0, _lib.callEventMethods)(e, 'persist', 'preventDefault', 'stopPropagation');

      if (_this.props.disabled) {
        return;
      }

      var multiple = _this.props.multiple;
      var newValue = _this.state.value;

      if (multiple) {
        var index = newValue.findIndex(function (v) {
          return v === value;
        });

        if (index > -1) {
          newValue.splice(index, 1);
        } else {
          newValue.push(value);
        }
      } else {
        // override current value
        newValue = value;
      }

      _this.setState({
        value: newValue
      }, function () {
        var _this$props2 = _this.props,
            onChange = _this$props2.onChange,
            name = _this$props2.name;

        if (onChange) {
          onChange(e, {
            name: name,
            value: newValue
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function (e) {
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          onClick = _this$props3.onClick;

      if (disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      (0, _lib.callEventMethods)(e, 'persist');

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnToggle", function (e) {
      var active = _this.state.active;
      var _this$props4 = _this.props,
          disabled = _this$props4.disabled,
          onClick = _this$props4.onClick;
      (0, _lib.callEventMethods)(e, 'preventDefault', 'stopPropagation');

      if (disabled) {
        return;
      }

      if (!active) {
        _this.handleOnOpen(e);
      } else {
        _this.handleOnClose(e);
      }

      if (onClick) {
        onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (!_this.state.active) {
        _this.setState({
          active: true
        }, function () {
          var _this$props5 = _this.props,
              onOpen = _this$props5.onOpen,
              as = _this$props5.as;

          if (as !== 'select') {
            document.addEventListener('click', _this.handleCheckClose);
          }

          if (onOpen) {
            onOpen(e);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClose", function (e) {
      (0, _lib.callEventMethods)(e, 'persist', 'stopPropagation');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      if (_this.state.active) {
        _this.setState({
          active: false
        }, function () {
          var _this$props6 = _this.props,
              onClose = _this$props6.onClose,
              as = _this$props6.as;

          if (as !== 'select') {
            document.removeEventListener('click', _this.handleCheckClose);
          }

          if (onClose) {
            onClose(e);
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCheckClose", function (e) {
      (0, _lib.callEventMethods)(e, 'stopPropagation');
      var active = _this.state.active;

      if (active) {
        if (!e.currentTarget.classList.contains(_Option.default.className)) {
          // if click on dropdown item, wont close, otherwise close
          _this.handleOnClose(e);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      var _this$state = _this.state,
          options = _this$state.options,
          value = _this$state.value;

      if ((0, _lib.arrayHasItems)(options)) {
        var _this$props7 = _this.props,
            multiple = _this$props7.multiple,
            itemNode = _this$props7.itemNode;

        if (multiple) {
          return _react.default.createElement("div", {
            className: "MHub-Select-Option-Container"
          }, options.map(function (item, idx, arr) {
            return itemNode(item, idx, arr, {
              onSelect: _this.handleOnSelect,
              selected: value.some(function (v) {
                return v === item.value;
              })
            });
          }));
        }

        return options.map(itemNode);
      }

      return null;
    });

    var _value = props.value,
        defaultValue = props.defaultValue,
        _options = props.options,
        placeholder = props.placeholder;
    _this.state = {
      prevProps: {
        value: _value,
        options: _options,
        placeholder: placeholder
      },
      value: _value || defaultValue,
      options: SelectBase.getOptions(_options, placeholder),
      active: false
    };
    return _this;
  }

  _createClass(SelectBase, [{
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          as = _this$props8.as,
          className = _this$props8.className,
          value = _this$props8.value,
          defaultValue = _this$props8.defaultValue,
          onClick = _this$props8.onClick,
          onChange = _this$props8.onChange,
          onOpen = _this$props8.onOpen,
          onClose = _this$props8.onClose,
          options = _this$props8.options,
          itemNode = _this$props8.itemNode,
          innerRef = _this$props8.innerRef,
          multiple = _this$props8.multiple,
          rest = _objectWithoutProperties(_this$props8, ["as", "className", "value", "defaultValue", "onClick", "onChange", "onOpen", "onClose", "options", "itemNode", "innerRef", "multiple"]);

      var Wrapper = (0, _lib.getElementType)(this, this.props);
      var classNames = this.classNames();
      var selectRef = innerRef || this.innerRef;
      return _react.default.createElement(Wrapper, _extends({}, rest, {
        ref: selectRef,
        className: classNames,
        value: this.state.value,
        onClick: as !== 'select' ? this.handleOnToggle : onClick,
        onChange: as === 'select' ? this.handleOnChange : null
      }), this.renderOptions());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          options = props.options,
          placeholder = props.placeholder;
      return {
        // Store the previous props in state
        prevProps: {
          value: value,
          options: options,
          placeholder: placeholder
        },
        value: prevProps.value !== value ? value : state.value,
        options: prevProps.options !== options || prevProps.placeholder !== placeholder ? SelectBase.getOptions(options, placeholder) : state.options
      };
    }
  }, {
    key: "getOptions",
    value: function getOptions(options, placeholder) {
      var newOptions = [];

      if (placeholder) {
        newOptions.push({
          value: '',
          title: placeholder,
          disabled: true
        });
      }

      if ((0, _lib.arrayHasItems)(options)) {
        newOptions = newOptions.concat(options);
      }

      return newOptions.map(SelectBase.mapOption);
    }
  }]);

  return SelectBase;
}(_react.PureComponent);

exports.default = SelectBase;

_defineProperty(SelectBase, "Option", _Option.default);

_defineProperty(SelectBase, "className", 'MHub-Select-Base');

_defineProperty(SelectBase, "displayName", 'SelectBase');

_defineProperty(SelectBase, "propTypes", {
  as: _common.customPropTypes.as,
  value: _common.customPropTypes.stringOrNumber,
  defaultValue: _common.customPropTypes.stringOrNumber,
  name: _propTypes.default.string,
  className: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  onClick: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_common.customPropTypes.stringOrNumber, _propTypes.default.shape({
    value: _common.customPropTypes.stringOrNumber.isRequired,
    label: _propTypes.default.string,
    name: _propTypes.default.string,
    text: _propTypes.default.string,
    title: _propTypes.default.string,
    disabled: _propTypes.default.bool
  })])),
  itemNode: _propTypes.default.func,
  innerRef: _common.customPropTypes.ref,
  multiple: _propTypes.default.bool
});

_defineProperty(SelectBase, "defaultProps", {
  as: 'select',
  value: undefined,
  defaultValue: '',
  name: null,
  className: null,
  placeholder: null,
  onClick: null,
  onChange: null,
  onOpen: null,
  onClose: null,
  disabled: false,
  readOnly: false,
  options: undefined,
  itemNode: function itemNode(_ref2, idx) {
    var title = _ref2.title,
        rest = _objectWithoutProperties(_ref2, ["title"]);

    return _react.default.createElement(_Option.default, _extends({}, rest, {
      key: idx
    }), title);
  },
  innerRef: null,
  multiple: false
});